const emptyValue = "—";
const isoDateTime =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})$/i;
const utcDateTime = new Intl.DateTimeFormat("en-GB", {
  timeZone: "UTC",
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
});

export function valueText(value: unknown): string {
  if (value === null || value === undefined || value === "") return emptyValue;
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (value instanceof Date)
    return Number.isFinite(value.getTime())
      ? value.toISOString()
      : String(value);
  if (typeof value === "object") {
    try {
      return JSON.stringify(value) ?? emptyValue;
    } catch {
      return String(value);
    }
  }
  return String(value);
}

/** Formatting only: retain the exact API timestamp for inspection and copying. */
export function formatDateTime(value: unknown): string {
  if (value === null || value === undefined || value === "") return emptyValue;
  if (
    !(value instanceof Date) &&
    typeof value !== "string" &&
    typeof value !== "number"
  ) {
    return valueText(value);
  }
  const date = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(date.getTime())) return valueText(value);
  return `${utcDateTime.format(date)} UTC`;
}

export function isCopyableField(field: string): boolean {
  if (/^brand[_.\s-]*ids?$/i.test(field)) return false;
  return (
    /^(?:id|uuid|token|seed|hash|key|email|url|ipAddress)$/i.test(field) ||
    /(?:Id|ID|Uuid|UUID|Token|Seed|Hash|Key|Email|Url|URL|Link|Address)s?$/.test(
      field,
    ) ||
    /[_.-](?:id|uuid|token|seed|hash|key|email|url)s?$/i.test(field)
  );
}

export function isDateTimeField(field: string, value?: unknown): boolean {
  const dateField =
    /(?:At|Date|Time|Timestamp)$/.test(field) || /^timestamp$/i.test(field);
  if (value === null || value === undefined || value === "") return dateField;
  // An ISO timestamp must be formatted even if an endpoint gives it a generic name.
  // Numeric duration fields such as responseTime must stay numeric.
  return (
    value instanceof Date ||
    (typeof value === "string" && isoDateTime.test(value))
  );
}
